import { FileTextIcon } from 'lucide-react'

import { UpgradeButton } from '@/modules/auth'
import { SAMPLE_ANALYSIS } from '../sampleReport'
import AnalysisReportSection from './AnalysisReportSection'
import { ReportDownloadsAllowed } from './AnalysisReportSection/DownloadMenu'
import { ReportLinksToCaseTransactions } from './AnalysisReportSection/ReportTable'

const SampleBanner = () => (
  <div
    role="note"
    className="flex max-w-6xl flex-wrap items-center gap-3 rounded-lg border bg-white px-4 py-3"
  >
    <FileTextIcon className="text-brand size-4 shrink-0" aria-hidden />
    <p className="flex-1 text-sm">
      <strong className="font-semibold">Sample report.</strong> Want a detailed
      analysis like this for your case? Upgrade now to get full access.
    </p>
    <UpgradeButton size="sm" />
  </div>
)

export default function SampleReport({ slug }: { slug: string }) {
  return (
    <div className="flex flex-col gap-4">
      <SampleBanner />
      <ReportDownloadsAllowed.Provider value={false}>
        <ReportLinksToCaseTransactions.Provider value={false}>
          <AnalysisReportSection slug={slug} analysis={SAMPLE_ANALYSIS} />
        </ReportLinksToCaseTransactions.Provider>
      </ReportDownloadsAllowed.Provider>
    </div>
  )
}
